import React from 'react';

type Props = {
  className?: string;
};

const Icon: React.FC<Props> = ({className=''}: Props) => (
  <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
    <path d="M8 9.86667L0 1.86667L1.86667 0L8 6.13333L14.1333 0L16 1.86667L8 9.86667Z" fill="#858585" className={className}/>
  </svg>
);

export default Icon;
